/**
 * <ClassCalendar
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
//
import moment from 'moment';
import BigCalendar from 'vendor/react-big-calendar'
import 'vendor/react-big-calendar/less/styles.less'
import 'vendor/react-big-calendar/addons/dragAndDrop/styles.less';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import Event from "./Event";
import color from 'color';

import Loading from 'components/UI/Loading'

import Transition from 'components/UI/Transition';

import './ClassCalendar.scss';

import LessonFloat from 'template/Floats/LessonFloat';

import Lesson from 'mediators/Lesson';

import AddLessonDock from 'template/Docks/AddLesson';
import __R, { userCan } from 'containers/__R'

//
// language
//

BigCalendar.momentLocalizer(moment);

const formats = {
  eventTimeRangeFormat: ({ start, end }, culture, local) => ''
}

const Calendar = withDragAndDrop(BigCalendar);

const DEFAULT_VIEW = 'month'

class ClassCalendar extends React.Component {
  static propTypes = {
    events: PropTypes.array.isRequired,
  }

  constructor(props) {
    super(props);

    this._eventPropGetter = this._eventPropGetter.bind(this);
    this.onSelectSlot = this.onSelectSlot.bind(this);
    this.onSelectEvent = this.onSelectEvent.bind(this);
    this.closeFloat = this.closeFloat.bind(this);

    this.state = {

    }
  }

  onSelectSlot(slot) {
    AddLessonDock({
      startDate: moment(slot.start).format('YYYY-MM-DD'),
      disablePrivateClass: userCan('create_private_lesson') != true,
      disableClass: userCan('create_lesson') != true,
    })
    .then((result)=>{
      this.props.onNavigate(result.response_datetime);
    });
  }


  onSelectEvent(lessonRaw, {currentTarget}) {
    this.setState({
      showLessonFloat: true,
      lessonEventTarget: currentTarget,
      lessonEvent: new Lesson(lessonRaw),
    });
  }

  closeFloat() {
    this.setState({
      showLessonFloat: false,
      lessonEventTarget: null,
      lessonEvent: null,
    });
  }

  //
  // event is a reserved word in javascript
  //
  _eventPropGetter(evnt) {
    return {
      style: {
        borderLeft: "6px solid " + (evnt.calendarColor || "#2196F3"),
        backgroundColor: color(evnt.calendarColor || "#aaa").fade(0.88),
      }
    }
  }

  render() {
    let {
      events,
      timeslots,
      onEventDrop,
      components,
      onNavigate,
      fetching,
      date,
    } = this.props;

    let {
      showLessonFloat,
      lessonEventTarget,
      lessonEvent,
    } = this.state;

    return (
      <div className={classnames('class-calendar', { 'fetching': fetching })}>
        { fetching && <Loading onPanel={true} /> }
        <Calendar
          selectable={true}
          popup={true}
          events={events}
          defaultView={DEFAULT_VIEW}
          min={new Date(0, 0, 0, 6, 0, 0, 0)}
          max={new Date(0, 0, 0, 23, 59, 59, 59)}
          date={date}
          views={['month', 'week', 'day']}
          step={15}
          components={{
            event: Event,
            ...components,
          }}
          timeslots={timeslots}
          onNavigate={onNavigate}
          onSelectSlot={this.onSelectSlot}
          onSelectEvent={this.onSelectEvent}
          onEventDrop={onEventDrop}
          formats={formats}
          eventPropGetter={this._eventPropGetter}
        />
        <LessonFloat
          lesson={lessonEvent}
          show={showLessonFloat}
          target={lessonEventTarget}
          onCloseFloat={this.closeFloat}
          onChange={(res)=>{
            if (res) {
              onNavigate(res.start_datetime)
            } else {
              onNavigate();
            }
          }}
        />
      </div>
    )
  }
}

export default ClassCalendar;



// WEBPACK FOOTER //
// ./src/template/ClassCalendar/index.js